module.exports = __webpack_public_path__ + "img/Dahlberg-22.a6f938f1.jpg";